import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Box, Button, Collapse, Grid2 } from '@mui/material';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { BOX_SHADOW, Website_Url } from '../../shared/constants';
import { useCourseApartmentList, useCourseDetail, useNewCourseDetail, useNewCourseDetail1, useNewCourseDetailPro, useNewCourseDetailPro1, useSchoolList } from '../../assets/api/useGetApi';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { TextSkeleton } from '../../shared/utils/SkeletonCom';
import useAuthStore from '../../shared/store/useAuthStore';
import { useDialog } from '../../shared/hook/useDialog';
import MainDialogBox from '../../shared/components/Dialog/DialogMainBox';
import { ImgText } from '../../shared/utils/Heading';
import CustomDivider, { OrDivider } from '../../shared/utils/CustomDivider';
import { Formik, Field, Form } from "formik";
import * as yup from "yup";
import useResponsive from '../../shared/utils/Responsive'
import { AutoCompleteField } from '../../shared/components/FormFields/AutoCompleteField';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { CutCurrency } from '../../shared/utils/CutCurrency';
import { CustomTooltip } from '../../shared/utils/CustomTooltip';
import useCouponStore from '../../shared/store/useCouponStore';
import CouponBoxUi from '../../shared/utils/CouponBoxUi';
import { useCoursePayment } from '../../shared/utils/useCoursePayment';
import { useCourseFreePayment } from '../../shared/utils/useCourseFreePayment';
import useVisitedPathStore from '../../shared/store/useVisitedPathStore';
import { useProCoursesPayment } from '../../shared/utils/useProCoursesPayment';
import { FormAutoComplete } from '../../shared/components/FormFields/FormAutoComplete';
import { useToaster } from '../../shared/utils/ToasterProvider';
import { FullScreenLoader } from './SubscribedCard';



function mergeMilestones(actualArray, checkedArray) {
    return actualArray?.map(milestone => {
        const checkedMilestone = checkedArray?.find(
            cm => cm?.milestone_id === milestone?.milestone_id
        );

        // Merge sprints with selection info
        const updatedSprints = milestone?.sprints?.map(sprint => {
            let sprintSelected = 0;

            if (checkedMilestone && checkedMilestone?.sprints?.length > 0) {
                const checkedSprint = checkedMilestone?.sprints?.find(
                    cs => cs?.sprint_id === sprint?.sprint_id
                );
                sprintSelected = checkedSprint ? 1 : 0;
            }

            return { ...sprint, selected: sprintSelected };
        });

        // Milestone selected = 1 only if at least one sprint is selected
        const milestoneSelected =
            updatedSprints.some(s => s?.selected === 1) ? 1 : 0;

        return {
            id: milestone.milestone_id,
            selected: milestoneSelected,
            name: milestone.milestone_name,
            start_date: milestone.start_date,
            end_date: milestone.end_date,
            price: milestone.price,
            reduction_price: milestone.reduction_price,
            sprints: updatedSprints,

        };
    });
}

const hasAnySprintSelected = (checkedArray) => {
    if (!checkedArray || !Array.isArray(checkedArray)) return false;

    // Check if at least one sprint in any milestone is selected
    return checkedArray.some(milestone =>
        Array.isArray(milestone.sprints) && milestone.sprints.some(sprint => !!sprint)
    );
};




export const PriceUi = ({ totalPrice, isOnline = false }) => {
    const { slug, apartments_id } = useParams();
    const { couponData } = useCouponStore();
    const message = "Check out this awesome website!";
    const url = isOnline ? `${Website_Url}OnlineCourseDetail/${slug}` : `${Website_Url}CoursesDetail/${slug}/${apartments_id}`;
    const encodedMessage = encodeURIComponent(`${message} ${url}`);
    const handleWhatsAppShare = () => {
        window.open(
            `https://wa.me/?text=${encodedMessage}`,
            '_blank',
            'noopener,noreferrer'
        );
    };
    return (
        <>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 1 }}>
                <>
                    {
                        couponData?.isPassed &&
                        <CutCurrency value={totalPrice} />
                    }
                    <Typography variant="h5" sx={{ display: "flex", alignItems: "center" }}>

                        {couponData?.finalPrice === 0 ? <Typography variant="h5" color='green'> free </Typography> : <>    <CurrencyRupeeIcon sx={{ color: "red.main" }} /> {couponData?.finalPrice}</> || '0'}
                    </Typography>
                </>
                <CustomTooltip icon='ic:round-share' onClick={handleWhatsAppShare} />
            </Box>
            <CustomDivider size="1rem" />

        </>
    )
}

const SubscribedCardTypeThree = ({ children, totalPrice, filteredCourse }) => {
    const [isProcessing, setIsProcessing] = React.useState(false);
    const { slug, apartments_id } = useParams();
    const { data: newCourse1, isLoading: isNewCourseLaoding1 } = useNewCourseDetail({ slug: slug });
    const { data: newCoursePro, isLoading: isNewCourseLaodingPro } = useNewCourseDetailPro({ slug: slug });
    const isProCourse = newCoursePro?.data?.type === 8
    const newCourse = isProCourse ? newCoursePro : newCourse1
    const { couponData } = useCouponStore();
    const { data: newCoursesDetail1, isLoading: isloadingNewCourses1 } = useNewCourseDetail1({ slug: slug, apartments_id: apartments_id })
    const { data: newCoursesDetailPro, isLoading: isloadingNewCoursesPro } = useNewCourseDetailPro1({ slug: slug })
    const location = useLocation();
    const newCoursesDetail = isProCourse ? newCoursesDetailPro : newCoursesDetail1
    const isloadingNewCourses = isProCourse ? isloadingNewCoursesPro : isloadingNewCourses1
    const navigate = useNavigate();
    const isSmallScreen = useResponsive("sm")
      const token = useAuthStore((state) => state.accessToken);
    const user = useAuthStore((state) => state.user);
    const { open: openDialog, handleClickOpen, handleClose } = useDialog();
    const { data: coursesApartmentList, isLoading: isLoadingApartmentList } = useCourseApartmentList({ "course_slug": slug });
    const { data: coursesDetail, isLoading } = useCourseDetail(slug);
    const payload = mergeMilestones(newCoursesDetail?.data?.[0]?.milestones
        , filteredCourse?.milestones
    )
    const apartmentOptions = coursesApartmentList?.data?.map((apartment) => ({
        id: apartment?.id,
        label: apartment?.apartment_name,
        value: apartment?.apartment_name,
    })) || []
    const { data: schoolList, isLoading: isSchoolLoading } = useSchoolList()
    const schoolOption = schoolList?.data?.map((item, index) => ({
        id: index + 1,
        label: item?.school_name,
        value: item?.school_name,
    })) || [];
    
    const paymentHook = couponData?.finalPrice === 0 ? useCourseFreePayment : useCoursePayment;



    const { showToaster } = useToaster();
    
    const proPayment = useProCoursesPayment({
        course_id: newCoursesDetail?.data?.[0]?.course_id,
        course_Name: newCoursesDetail?.data?.[0]?.course_name,
        coverImage: coursesDetail?.data?.cover_image,
        start_date: newCoursesDetail?.data?.[0]?.start_date,
        end_date: newCoursesDetail?.data?.[0]?.end_date,
        order_details: {
            course_name: newCoursesDetail?.data?.[0]?.course_name,
        },
        sessions: filteredCourse,
        school_name: apartments_id,
        firstpayload: {
            "school_id": user?.school_id,
            "facility_id": 0,
            "course_id": newCoursesDetail?.data?.[0]?.course_id,
            "batch_id": 0,
            "start_date": newCoursesDetail?.data?.[0]?.start_date ?? "1-1-2025",
            "end_date": newCoursesDetail?.data?.[0]?.end_date ?? "1-1-2025",
            "course_fees": couponData?.finalPrice,
            "course_reduction_fees": null,
            "school_code": user?.schoolcode,
            "course_code": newCourse?.data?.course_code,
            milestone: payload
        },
        secondpayload: {
            "name": user?.firstname,
            "school_code": user?.schoolcode,
            "email": user?.email,
            "password": user?.password,
            "status": "active",
            "role": [2]
        }
    });

    const normalPayment = paymentHook({
        course_id: newCoursesDetail?.data?.[0]?.course_id || coursesDetail?.data?.id || newCourse?.data?.id,
        course_Name: newCoursesDetail?.data?.[0]?.course_name,
        apartment_name: newCoursesDetail?.data?.[0]?.apartment_name,
        coverImage: coursesDetail?.data?.cover_image,
        apartments_id: apartments_id,
        batch_id: null,
        start_date: newCoursesDetail?.data?.[0]?.batch_start_date,
        end_date: newCoursesDetail?.data?.[0]?.batch_end_date,
        order_details: filteredCourse,
        onProcessingChange: setIsProcessing  
    });

    const { handlePayment, SuccessDialog } = isProCourse
        ? proPayment
        : normalPayment;
    const validationSchema = yup.object().shape({
        apartment: yup.string().required('Apartment is required'),
    });

    const handleSubmit = (values) => {
        navigate(`/CoursesDetail/${slug}/${values?.apartment}`)
        handleClose()
    };
    const [open, setOpen] = React.useState(false);
    const buttonUi = () => {
        return (
            <Button variant="contained" fullWidth
              

                disabled={
                    apartments_id && token
                        ? (
                            isProCourse
                                ? !(user?.role === "teacher" || user?.role === "school") // disable if not teacher or school
                                : user?.role !== "student" // disable if not student
                        )
                        : false
                }


                onClick={() => {
                    if (!apartments_id) {
                        handleClickOpen();
                    } else {
                        if (isProCourse) {
                            if (hasAnySprintSelected(filteredCourse?.milestones)) {
                                handlePayment();
                            } else {
                                showToaster(
                                    'Warning',
                                    'Please select at least one milestone to purchase.',
                                    'warning'
                                );

                            }
                        } else {
                            handlePayment();
                        }
                    }
                }}
            >
                {(apartments_id) ? "Purchase Now" : "Enroll Now"}
            </Button>
        )
    }

    return (
        <>
            <FullScreenLoader open={isProcessing}/>
            <Box sx={{
                borderRadius: isSmallScreen ? "10px" : "40px",
                position: isSmallScreen ? "fixed" : "relative",
                bottom: "0",
                bgcolor: "#fff",
                zIndex: 100,
                width: isSmallScreen ? "100%" : "auto",
                boxShadow: BOX_SHADOW,
                border: "1px solid #F0F0F0",
            }}>


                {
                    isSmallScreen && apartments_id && <>
                        <Box
                            onClick={() => setOpen(prev => !prev)}

                            sx={{
                                cursor: 'pointer',
                                display: "flex",
                                justifyContent: 'center',
                                alignItems: 'center',

                            }}
                        >
                            <ExpandLessIcon
                                sx={{
                                    transform: open ? 'rotate(180deg)' : 'rotate(0)',
                                    transition: '0.3s',
                                }}
                            />
                        </Box>

                        <Collapse in={open} orientation="vertical" unmountOnExit>
                            <Box sx={{
                                height: "10rem",
                                width: '100%',
                                bgcolor: '#fff',
                                boxShadow: true ? 'none' : '0px -4px 10px -2px rgba(0,0,0,0.15)',
                                p: 2,
                                borderTopLeftRadius: isSmallScreen ? '10px' : '20px',
                                borderTopRightRadius: isSmallScreen ? '10px' : '20px',
                                overflowY: 'auto',
                            }}>
                                {children}
                            </Box>
                        </Collapse>
                    </>
                }
                <Card
                    sx={{

                        p: "32px 22px",
                        boxShadow: { xs: "none", md: BOX_SHADOW },
                        border: { xs: "1px solid #F0F0F0", md: "none" },
                        borderRadius: isSmallScreen ? "10px" : "40px",

                    }}>

                    {
                        !isSmallScreen && <>
                            <CardContent>

                                {apartments_id && <>
                                    < PriceUi totalPrice={totalPrice} />
                                    {children}
                                </>

                                }

                                {buttonUi()}

                                {isLoading && <TextSkeleton line={1} width={50} margin={"0 auto"} />}
                                {!isLoading && newCourse?.data?.type === 5 && newCourse?.data?.title !== "MISSION DOMINO FALL" && <Typography variant='body1' fontSize={"12px"} textAlign={"center"} color='red.main' mt={2}>
                                    {coursesDetail?.data?.title}
                                </Typography>}
                                {
                                    newCourse?.data?.type === 5 && newCourse?.data?.title === "MISSION DOMINO FALL" &&
                                    <Typography
                                        variant="body2"
                                        color="red.main"
                                        sx={{
                                            mt: 1,
                                            cursor: "pointer",
                                            textDecoration: "underline",
                                            textAlign: "center",
                                        }}

                                        mt={2}
                                        onClick={() => navigate("/FinalPriceDestribution")}
                                    >
                                        View Leader Board
                                    </Typography>
                                }
                                {
                                    apartments_id && <CouponBoxUi totalPrice={totalPrice} />
                                }

                            </CardContent>
                        </>
                    }

                    {
                        isSmallScreen && <>

                            <>
                                <CardContent sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>

                                    {
                                        apartments_id && <PriceUi totalPrice={totalPrice} />
                                    }
                                    {buttonUi()}
                                </CardContent>
                                <CustomDivider size={"10px"} />

                                {
                                    apartments_id && <CouponBoxUi totalPrice={totalPrice} />
                                }


                            </>


                        </>
                    }


                </Card>



                <MainDialogBox open={openDialog} handleClose={handleClose} width={"50%"}>
                    <Box sx={{ display: 'flex', flexDirection: "column", alignItems: "center" }}>
                        <ImgText text={"We’d love to know your preference!"} sx={{ fontSize: "30px" }} />
                        <Typography variant='body2' textAlign={"center"} my={1}>Which {isProCourse ? "School" : "location"} would you prefer to attend the Course at? Please select your preferred option below.</Typography>
                        <Box my={4} width={"60%"}>
                            <Formik
                                initialValues={{ apartment: "" }}
                                validationSchema={validationSchema}
                                onSubmit={handleSubmit}
                            >
                                {() => (
                                    <Form>
                                        <Grid2 container spacing={2}>
                                            {
                                                isProCourse ? <Grid2 children size={{ xs: 12, sm: 12 }}>
                                                    <Field
                                                        name="apartment"
                                                        component={FormAutoComplete}
                                                        options={schoolOption}
                                                        label="School"
                                                        isRequired={true}
                                                        isLoading={isSchoolLoading}
                                                        nooptionText={"Currently Unavailable"}
                                                   
                                                    />
                                                </Grid2> : <Grid2 children size={{ xs: 12, sm: 12 }}>
                                                    <Field
                                                        name="apartment"
                                                        component={AutoCompleteField}
                                                        options={apartmentOptions}
                                                        label="Apartment"
                                                        isRequired={true}
                                                        isLoading={isLoadingApartmentList}
                                                        nooptionText={"Currently Unavailable"}
                                                        isShow={true}

                                                    />
                                                </Grid2>
                                            }


                                            <Grid2 children size={{ xs: 12, sm: 12 }}>
                                                <Button variant='contained' fullWidth type="submit">Verify</Button>

                                            </Grid2>
                                        </Grid2>

                                    </Form>
                                )}
                            </Formik>
                        </Box>


                        {
                            !token && <>{

                                isProCourse ?
                                    <>
                                        <OrDivider text={"Or"} />
                                        <Typography variant='h6' fontSize={"12px"} color='grey.100' >Didn't not Found your School , Please <Typography component={"span"} variant='h6' fontSize={"12px"} color='red.main' sx={{ cursor: "pointer" }} onClick={() => {
                                            useVisitedPathStore.getState().setLastVisitedPath(location.pathname);
                                            localStorage.setItem("lastVisitedPath", location.pathname);
                                            navigate('/Apartmentonboarding?tab=3', { state: { selected: "School" } });
                                        }}> Onboard.</Typography></Typography>
                                    </> : <>
                                        <OrDivider text={"Sign in for a better experience!"} />
                                        <Typography variant='h6' fontSize={"12px"} color='grey.100' >Get personalized event updates, faster check-in, and exclusive perks.</Typography>
                                    </>
                            }
                            </>
                        }
                    </Box>
                </MainDialogBox>
                <SuccessDialog />
            </Box>


        </>




    )
}

export default SubscribedCardTypeThree



